import { observeLazySources } from './modules/lazy-sources-loader.js';
import { initNewsBlocksAnalytics } from './modules/analytics.js';

/* need for old browsers without defer */
document.addEventListener(
  `DOMContentLoaded`,
  () => {
    initNewsBlocksAnalytics();

    /* initialization of lazy loading */
    observeLazySources();
  },
  false,
);
